<template lang="pug">
.mobile-header.pushy_white(data-aos='fade-left' data-aos-offset="500" data-aos-duration="500")
  nav.mo_head_tab
    ul
      li.pushy-link
        a(@click='goTo("info")' v-if="lan == 'kr'") 회사소개
        a(@click='goTo("info")' v-else) Company
      li.pushy-link
        a(@click='goTo("smart")') Smart Brewery
      li.pushy-link
        a(@click='goTo("nano")') Nano Brewery
      li.pushy-link
        a(@click='goTo("news")') NEWS
      li.pushy-link
        a(@click='goTo("store")' v-if="lan == 'kr'") 설치매장
        a(@click='goTo("store")' v-else) Find INTHEKEG
      li.pushy-link
        a(@click='goTo("contact")') CONTACT
  .lang_btn
    ul
      li(:class='[lan == "kr" ? "on" : ""]')
        a(@click='selectLang("kr")') KOR
      li(:class='[lan == "en" ? "on" : ""]')
        a(@click='selectLang("en")') ENG
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
export default {
  data() {
    return {};
  },
  computed: {
    ...mapGetters(['lan']),
  },
  methods: {
    ...mapActions(['getLang']),
    goTo(name) {
      this.$emit('close-header');
      this.$_goTo({ name: name });
    },
    selectLang(lang) {
      this.getLang(lang);
      let name = this.$route.name;
      this.$emit('close-header');
      this.$_goTo({ name: name.replace('en-', '') });
    },
  },
  mounted() {},
  created() {},
};
</script>

<style scoped>
@import '../../assets/css/pushy.css';
.fade-enter-active,
.fade-leave-to {
  transition: opacity 0.5s;
}
.top_nav {
  height: 90px;
}
.mobile-header {
  width: 100%;
  height: 100%;
  right: 0;
  top: 60px;
  position: fixed;
  z-index: 500;
  transition: transform 0.2s cubic-bezier(0.16, 0.68, 0.43, 0.99);
  /* visibility: hidden; */
}
/* .mobile-header: */
.aa {
  visibility: visible;
}
</style>
